<template>
    <div class="clients-import">
        <div>
            <span
                class="heading"
                :class="mode"
            >
                {{ $t('clients.import.heading') }}
            </span>

            <v-form ref="importForm">
                <v-file-input
                    v-model="clientsFile"
                    class="mt-5"
                    accept=".xlsx, .xls, .csv"
                    :label="$t('clients.import.file')"
                    :rules="[CodForm.rule('required')]"
                    clearable
                    outlined
                    prepend-inner-icon="fal fa-paperclip"
                    prepend-icon=""
                    clear-icon="fal fa-times"
                />
            </v-form>

            <v-fade-transition>
                <div v-if="failedClients && failedClients.length">
                    <div class="mb-3 error--text text-body-2">
                        {{ $t('products.import.fail') }}
                    </div>
                    <ul
                        v-for="(client, index) in failedClients"
                        :key="index"
                        class="error--text text-body-2"
                    >
                        <li>{{ `${$tc('general.row', 1)} #${client.row}: ` + $t(`clients.import.errors.${client.error[0]}`) }}</li>
                    </ul>
                </div>
            </v-fade-transition>
        </div>
    </div>
</template>

<script>
import ApiService from '@/services/ApiService';

export default {
    props: {
        mode: {
            type: String,
            default: 'admin',
        },
    },

    data() {
        return {
            clientsFile: null,
            failedClients: [],
        };
    },
    watch: {
        clientsFile(val) {
            if(val) {
                this.failedClients = [];
            }
        }
    },

    methods: {
        /*
        * Save clients imported from a local file
        */
        async importFile() {

            if (!this.$refs.importForm.validate()) return false

            let formData = new FormData();
            formData.append('clients', this.clientsFile);

            try {
                const apiUrl = `/${this.mode}/clients/import`;

                const response = await ApiService.post(apiUrl, formData, {

                    transformRequest: (data, headers) => {
                        this.$emit('importStarted', true);
                        headers.common['Content-Type'] = 'multipart/form-data';
                        return data;
                    }
                })

                this.reset();

                if(response.data.success) this.$snackbar(this.$t('clients.imported'), 'success');
                else {
                    this.failedClients = response.data.failedClients;
                    this.$emit('error')
                    this.$emit('importStarted', false);
                    return false;
                }

            } catch(error) {
                this.failedClients = error.response.data.errors;
                return false;
            }

            return true
        },

        /*
        * Close import form and clear contents
        */
        reset() {
            this.clientsFile = null;
            this.failedClients = [];

            if(this.$refs.importForm) {
                this.$refs.importForm.resetValidation()
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.clients-import {
    .heading {
        margin-bottom: 30px;
        font-size: 14px;

        &.getstarted {
            color: #8f9095;
        }
    }
}
</style>
